/**
 * Transform location
 * @param {Array} input location
 * @returns {Array} location
 */
export const transformLocation = (input = {}) => {
	return {
		id: input.province_id ?? null,
		name: input.name_th || null,
	};
};

/**
 * Transform locations
 * @param {Array} input locations
 * @returns {Array} locations
 */
export const transformLocations = (input = []) => {
	return input.map((item) => transformLocation(item));
};
